import * as React from 'react';
import { SelectMultiple, SelectMultipleHierarchy } from 'app/area/shared/translated-components';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { FilterCommonProps, FilterCommonValues } from './types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeFieldWireKey } from 'app/area/codetable/types-store';
import { getCategoryId } from 'app/area/search-filters/filters/category-id';

interface FilterCodeHierarchyWithCategoryProps extends FilterCommonProps<string> {
  onLoadCategoryOptions?: (loadOptions: LoadOptions) => void;
  categoryOptions?: ComplexValue<number>[];
  categoryId?: number;
}

interface FilterCodeHierarchyWithCategoryState {
  loadedOptions: LoadOptions;
  loadedCategoryOptions: LoadOptions;
}

export class FilterCodeHierarchyWithCategory extends
  React.PureComponent<FilterCodeHierarchyWithCategoryProps, FilterCodeHierarchyWithCategoryState> {

  public state: Readonly<FilterCodeHierarchyWithCategoryState> = {
    loadedOptions: {},
    loadedCategoryOptions: {}
  };

  private onChange = (values: FilterCommonValues<string>[]) => {
    this.props.onChange(this.props.id, values);
  };

  private onLoadOptions = (options: LoadOptions) => {

    const { id, onLoadOptions, optionsEndpoint, optionsParams, loadOptionsParams, mapOptionsParams,
      mapOptionsRequestPayload } = this.props;
    const categoryId = isDefinedIncludingZero(options?.categoryId) ? options.categoryId : optionsParams?.categoryId;

    onLoadOptions(
      id,
      optionsEndpoint,
      { ...options, ...loadOptionsParams },
      {
        limitFieldsTo: [CodeFieldWireKey.code, CodeFieldWireKey.category],
        ...optionsParams,
        ...(mapOptionsParams?.({ categoryId }) ?? ({}))
      },
      {
        ...(mapOptionsRequestPayload?.({ categoryId }) ?? ({}))
      }
    );
    this.setState({ loadedOptions: options });
    return;
  };

  private onLoadCategoryOptions = (options: LoadOptions) => {

    const { id, onLoadOptions, categoryOptionsEndpoint, categoryOptionsParams, categoryLoadOptionsParams } = this.props;

    onLoadOptions(
      getCategoryId(id),
      categoryOptionsEndpoint,
      { ...options, ...categoryLoadOptionsParams },
      categoryOptionsParams
    );
    this.setState({ loadedCategoryOptions: options });
    return;
  };

  public render() {

    const { id, label, values, fetchingOptions, fetchingCategoryOptions, options, isHierarchy = true,
      allowQuerySearch, optionsParams, translation, categoryOptions, meatballPanelConfiguration, locale } = this.props;

    const { loadedOptions } = this.state;

    const selectComponentProps = {
      componentId: id,
      className: undefined,
      label: label ? { text: label } : undefined,

      valueItems: values || [],
      onChange: this.onChange,

      options,
      fetching: fetchingOptions || fetchingCategoryOptions,
      loadOptions: loadedOptions,
      onLoadOptions: this.onLoadOptions,

      minLength: optionsParams?.minLength,
      placeholder: translation?.search,

      displaySelectAll: true,
      displayCategories: true,
      onLoadCategoryOptions: this.onLoadCategoryOptions,
      categoryOptions,
      allowQuerySearch,
      meatballPanelConfiguration,
      locale
    };

    return isHierarchy
      ? <SelectMultipleHierarchy {...selectComponentProps} descriptionAllLevels={true} />
      : <SelectMultiple {...selectComponentProps} />;
  }
}
